import type { AccountExtension as AccountExtensionModel } from '@/adapters/catalogv1.g';

export function extractAccountExtension(model: AccountExtensionModel) {
  const attributes = model.attributes ?? [];
  const classifications = model.classifications ?? [];
  const riskFactors = model.risk_factors ?? [];

  return {
    id: model._metadata?.distinct_id ?? '',
    accountRef: model.account_ref ?? '',
    attributes,
    classifications,
    riskFactors,
    attributeCount: attributes.length,
    classificationCount: classifications.length,
    riskFactorCount: riskFactors.length,
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogAccountExtension = ReturnType<
  typeof extractAccountExtension
>;
